import { ListedInstrument } from '@eih-netbroker/common';
import { ReactComponent as SearchIcon } from '../../../../../assets/icons/search-line.svg';
import { useLocale } from '../../../../../context/NbLocalizationContext';
import { InstrumentSearchAutocomplete } from '../../../../../shared/components/instrument-search-autocomplete/InstrumentSearchAutocomplete';
import { cssWhen } from '../../../../../shared/utils/themeUtils';
import { PriceInfo } from '../common/PriceInfo';
import classes from './OrderFormInstrumentSearch.module.scss';

type OrderFormInstrumentSearchProps = {
  instrument: ListedInstrument | null;
  updateInstrument: (instrument: ListedInstrument | null) => void;
  source: string;
  transactionId?: string;
  disabled?: boolean;
  readOnly?: boolean;
  className?: string;
};

export const OrderFormInstrumentSearch = (props: OrderFormInstrumentSearchProps) => {
  const { instrument, updateInstrument, transactionId, disabled, readOnly, className } = props;
  const { translation } = useLocale();

  return (
    <div className={cssWhen(classes.container, className)}>
      <InstrumentSearchAutocomplete
        isPopperWide
        selection={instrument}
        onSelectInstrument={updateInstrument}
        placeholder={translation.orderModal.instrumentSearchPlaceholder}
        transactionId={transactionId}
        disabled={disabled}
        readOnly={readOnly}
        dataTestId="order-instrument-search-input"
        inputProps={{
          InputProps: {
            endAdornment: <SearchIcon className={classes.searchIcon} />,
            className: classes.searchInput,
          },
        }}
      />
      {
        <div className={classes.instrumentRow}>
          <span
            className={classes.instrumentName}
            data-testid="order-form-instrument-name"
          >
            {instrument?.instrumentName}
          </span>
          <PriceInfo
            {...props}
            dataTestId="order-form-price-info"
          />
        </div>
      }
    </div>
  );
};
